// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__yMczw"};